<template>
  <div class="dataCenter">
    <div :class="['tab_box',{'tab_box1':activeTabIndex==1,'tab_box2':activeTabIndex==2,'tab_box3':activeTabIndex==3}]">
      <div class="item_box">
        <div :class="['tab_item',{'active_tab_item':activeTabIndex==item.id}]" v-for="item in tabList" :key="item.id" @click="changeTab(item)">{{ item.name }}</div>
      </div>
      <div class="title">
        核心结论
      </div>
      <div class="value">{{ tabList[activeTabIndex-1].value }}</div>
    </div>
    <div class="show_data_box">
      <div class="tip_list">兴趣分布<span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">随拍是粉丝最感兴趣</div>
      <div class="flowEachrts" ref="InterestEchartsRef"></div>
      <template v-if="activeTabIndex==1">
        <div class="tip_box" style="margin-top: 20px;">全部粉丝常搜的词</div>
        <div class="words_list" v-for="item in searchWordsData" :key="item.name">
          <div class="name_box">
            <div class="name">{{ item.name }}</div>
            <div class="value"><img style="width: 11px;margin-right: 5px;" src="../../assets/img/auAnalysis/hot.png" alt="">{{ item.value }}</div>
          </div>
          <div class="button">查看热词</div>
        </div>
        <div class="tip_box" style="margin-top: 20px;">全部粉丝爱看的视频</div>
        <div class="showFansLoveVideo" v-draggle-scroll-x>
          <div class="video_item" v-for="item in videoList" :key="item.name">
            <div class="img_box">
              <img :src="item.url" alt="">
            </div>
            <div class="name">{{ item.name }}</div>
            <div class="value">完播率 {{ item.value }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="tip">
      本页数据仅供参考，抖音对此不作任何类型的担保，用户个人对数据服务的使用应独立承担风险。
    </div>
  </div>
</template>
      
<script>
import {
  fansInterestDistribution,
  newFansInterestDistribution,
  runOfFansInterestDistribution,
} from "./js/Operatingdata";
import { draggleScrollX } from "../../utils/directives.js";
export default {
  data() {
    return {
      tabList: [
        {
          id: 1,
          name: "全部粉丝",
          value: "近期全部粉丝关注随拍最多",
        },
        {
          id: 2,
          name: "新增粉丝",
          value: "近期新增粉丝关注随拍最多",
        },
        {
          id: 3,
          name: "流失粉丝",
          value: "近期流失粉丝关注随拍最多",
        },
      ],
      activeTabIndex: 1,
      searchWordsData: [
        {
          name: "御姐",
          value: "82",
        },
        {
          name: "内容启发搜索",
          value: "69",
        },
        {
          name: "温泉",
          value: "60",
        },
        {
          name: "情侣日常",
          value: "56",
        },
        {
          name: "心理学",
          value: "53",
        },
      ],
      videoList: [
        {
          url: require("../../assets/img/incomeData/v1.png"),
          name: "让你脱胎换骨的...",
          value: "4.43%",
        },
        {
          url: require("../../assets/img/incomeData/v2.png"),
          name: "拥有人格魅力,...",
          value: "3.46%",
        },
        {
          url: require("../../assets/img/incomeData/v3.png"),
          name: "他是鼓手吗 还是...",
          value: "9.26%",
        },
      ],
    };
  },
  directives: {
    draggleScrollX: draggleScrollX,
  },
  components: {},
  mounted() {
    this.getCtiyEcharts(1);
  },

  methods: {
    changeTab(item) {
      this.activeTabIndex = item.id;
      this.getCtiyEcharts(item.id);
    },
    getCtiyEcharts(type) {
      let chart = this.$echarts.init(this.$refs.InterestEchartsRef);
      var xData = [];
      var y1Data = [];
      if (type == 1) {
        xData = fansInterestDistribution.xData;
        y1Data = fansInterestDistribution.yData;
      } else if (type == 2) {
        xData = newFansInterestDistribution.xData;
        y1Data = newFansInterestDistribution.yData;
      } else {
        xData = runOfFansInterestDistribution.xData;
        y1Data = runOfFansInterestDistribution.yData;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: false, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 20,
          left: 40,
          right: 0,
        },
        dataZoom: {
          type: "slider",
          start: 0,
          end: type == 1 ? 50 : 20,
          // 固定手柄大小
          handleSize: 0,
          // 禁止缩放
          zoomLock: true,
          showDetail: false,
          // 背景颜色
          backgroundColor: "#ffffff",
          // 选中区域的背景颜色
          dataBackground: {
            lineStyle: {
              color: "#6a75f6",
            },
            areaStyle: {
              color: "rgba(249, 250, 254,.2) ",
            },
          },
          // 选中区域的颜色
          fillerColor: "rgba(215, 226, 250,.4)",
          // 边框颜色
          borderColor: "transparent",
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
            interval: 0,
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            min: 0,
            max: 40,
            interval: 20,
          },
        },
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#6a75f6", // 柱状图颜色
            },
            barWidth: 20,
            barCategoryGap: "50%",
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
  },
};
</script>
      
  <style scoped lang="scss">
.dataCenter {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  .tab_box {
    height: 160px;
    border: 4px;
    .item_box {
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      font-size: 16px;
      cursor: pointer;

      .tab_item {
        padding: 10px;
        color: #717278;
      }
      .active_tab_item {
        color: #fff;
      }
    }
    .title {
      padding: 15px 10px;
      box-sizing: border-box;
      color: #d9eafc;
      font-size: 16px;
    }
    .value {
      padding: 0px 10px;
      font-size: 22px;
      font-weight: 600;
      color: #fff;
    }
  }
  .tab_box1 {
    background: url("../../assets/img/fansData/bc1.png");
    background-size: 100% 100%;
  }
  .tab_box2 {
    background: url("../../assets/img/fansData/bc2.png");
    background-size: 100% 100%;
  }
  .tab_box3 {
    background: url("../../assets/img/fansData/bc3.png");
    background-size: 100% 100%;
  }
  .show_data_box {
    margin-top: 10px;
    padding: 10px 10px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    .tip_list {
      color: #7680f6;
      font-size: 14px;
      margin-top: 6px;
    }
    .tip_box {
      font-size: 16px;
      color: #8d8e93;
      margin-top: 5px;
    }
    .flowEachrts {
      width: 100%;
      height: 200px;
    }
    .words_list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      .name_box {
        .name {
        }
        .value {
          color: #7a7b81;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .button {
        padding: 6px 10px;
        background: #f3f3f3;
        border-radius: 6px;
      }
    }
    .showFansLoveVideo {
      display: flex;
      margin-top: 20px;
      .video_item {
        margin-right: 10px;
        .img_box {
          width: 120px;
          height: 180px;
          border-radius: 8px;
          background: skyblue;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
        .name {
          margin-bottom: 5px;
        }
        .value {
          color: #87888d;
          font-size: 13px;
        }
      }
    }
  }
  .tip {
    text-align: center;
    font-size: 12px;
    margin-top: 10px;
    padding-bottom: 30px;
    color: #a9aaad;
  }
}
</style>
      
      